import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { actions as tripActions } from '~/redux/reducers/trip';

const Container = styled.div`
  width: 288px;
  height: 112px;
  position: relative;
  border-radius: 6px;
  background-image: linear-gradient(293deg, #ff7823, #ff9b4e);
  @media(max-width: 700px) {
    width: 100%;
  }
`;

const Clip = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${props => props.theme.white};
`;

const TopClip = styled(Clip)`
  position: absolute;
  top: -12px;
  left: 16%;
`;

const BottomClip = styled(Clip)`
  position: absolute;
  bottom: -12px;
  left: 16%;
`;

const TextContainer = styled.div`
  padding: 24px 16px;
`;

const CopyText = styled.p`
  margin: 0 !important;
  padding-bottom: 8px;
  cursor: pointer;
  text-align: right;
  color: ${props => props.theme.white};
  font-size: 14px !important;
  font-weight: 400;
  line-height: 8px;
`;

const copyCode = (e, code) => {
  const textField = document.createElement('textarea');
  textField.innerText = code;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
  e.target.innerText = 'copied!';
};

const CouponCard = ({ code = '', renderText }) => {
  const dispatch = useDispatch();
  function onCopyCode(e) {
    copyCode(e, code);
    if (code === 'FIRSTBOOKING') {
      dispatch(tripActions.logCopyFirstBookingCode());
    }
  }
  return (
    <Container>
      <TopClip />
      <TextContainer>
        {renderText && renderText()}
        <CopyText onClick={onCopyCode} >copy</CopyText>
      </TextContainer>
      <BottomClip />
    </Container>
  );
};

CouponCard.propTypes = {
  renderText: PropTypes.func,
  code: PropTypes.string
};

export default CouponCard;
